import {
  ContentChild,
  Directive,
  ElementRef,
  EventEmitter,
  forwardRef,
  inject,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { autoClose, isBool } from '../helpers';

@Directive({
  selector: '[dropdownContent]'
})
export class DropdownContent {
  public readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
}

@Directive({
  selector: '[dropdownToggle]',
  host: {
    '(click)': 'dropdown.toggle()'
  }
})
export class DropdownToggle {
  constructor(
    @Inject(forwardRef(() => DropdownDirective)) public readonly dropdown: DropdownDirective
  ) { }
}

@Directive({
  selector: '[dropdown]',
  exportAs: 'dropdown'
})
export class DropdownDirective implements OnInit, OnDestroy {
  private readonly renderer = inject(Renderer2);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @ContentChild(DropdownContent, { static: false })
  private readonly content!: DropdownContent;

  @Input('dropdown')
  public initialState: any = false;

  @Input()
  public dropdownOpenClass!: string;

  @Input()
  public autoClose = true;

  @Input()
  public disabled = false;

  @Output()
  public dropdownOpen = new EventEmitter<void>();

  public readonly isOpen$ = new BehaviorSubject<boolean>(false);

  private destroyer$!: Subject<void>|undefined;

  ngOnInit(): void {
    if(isBool(this.initialState) && this.initialState) {
      this.open();
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  toggle(): void {
    if(this.disabled) {
      return;
    }
    
    if(this.isOpen$.value) {
      this.close();
    } else {
      this.open();
    }
  }

  open(): void {
    this.isOpen$.next(true);
    this.renderer.addClass(this.elementRef.nativeElement, this.dropdownOpenClass);
    this.dropdownOpen.emit();

    if(this.autoClose) {
      this.destroy();

      this.destroyer$ = autoClose(
        this.content.elementRef.nativeElement,
        () => this.close()
      );
    }
  }

  close(): void {
    this.destroy();
    this.renderer.removeClass(this.elementRef.nativeElement, this.dropdownOpenClass);
    this.isOpen$.next(false);
  }

  private destroy(): void {
    if(this.destroyer$) {
      this.destroyer$.next();
      this.destroyer$ = undefined;
    }
  }
}
